import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { SkeletonSizeBase } from '../../../common';

@Component({
  selector: 'skc-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.less', './table-material.component.less', './table-bootstrap.component.less']
})
export class TableComponent extends SkeletonSizeBase implements OnInit, OnChanges {
  @Input('skc-rows') rows = 3;
  @Input('skc-columns') columns = 3;
  @Input('skc-headers') headers = [];
  @Input('skc-skeleton-header') skeletonHeader = true;
  @Input('skc-border-row') borderRow = true;
  @Input('skc-border-header') borderHeader = true;
  @Input('skc-shadow-table') shadowTable = true;
  @Input('skc-footer') footer = false;
  @Input('skc-style-table') styleTable: 'default' | 'bootstrap' | 'material' = 'default';
  @Input('skc-padding-cell') paddingCell: string;
  @Input('skc-padding-header') paddingHeader: string;
  @Input('skc-padding-footer') paddingFooter = '70%';
  @Input('skc-margin-row') marginRow: string;
  widthFooter = '95%';
  rowsTable = [];
  columnsTable = [];
  columnsHeader = [];
  columnsWidth: number;
  widthCells: string[][] = new Array([]);

  constructor() {
    super();
  }

  ngOnInit() {
    this.getColumnsHeader();
    this.getColumnsTableArray();
    this.getRowsTableArray();
    this.getWidthCells();
  }

  getMatrixCell(rows, cols) {
    const arr = [];
    for (let i = 0; i < rows; ++i) {
      const columns = [];
      for (let j = 0; j < cols; ++j) {
        columns[j] = this.getRandomNumber();
      }
      arr[i] = columns;
    }
    return arr;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.rows && !changes.rows.firstChange) {
      this.getRowsChangeTableArray(changes);
      this.getWidthCells();
    }
    if (changes.columns && !changes.columns.firstChange) {
      this.getColumnsChangeTableArray(changes);
      this.getWidthCells();
    }
    if (changes.headers && !changes.headers.firstChange) {
      this.getColumnsChangeHeader(changes);
      this.getWidthCells();
    }
  }

  getWidthCells() {
    this.widthCells = this.getMatrixCell(this.rowsTable.length, this.columnsTable.length);
  }

  getRowsTableArray() {
    this.rowsTable = new Array(this.rows <= 0 ? 2 : this.rows);
  }

  getRowsChangeTableArray(changes: SimpleChanges) {
    this.rowsTable = new Array(changes.rows.currentValue <= 0 ? 2 : changes.rows.currentValue);
  }

  getColumnsTableArray() {
    if (this.headers.length !== 0) {
      this.columnsTable = new Array(this.headers.length);
    } else {
      this.columnsTable = new Array(this.columns <= 0 ? 3 : this.columns);
    }
  }

  getColumnsChangeTableArray(changes: SimpleChanges) {
    if (this.headers.length !== 0) {
      this.columnsTable = new Array(this.headers.length);
    } else {
      this.columnsTable = new Array(changes.columns.currentValue <= 0 ? 3 : changes.columns.currentValue);
    }
    this.getColumnsHeader();
  }

  getMinimalColumnsWidth() {
    return (this.columnsWidth = 100 / this.columnsTable.length);
  }

  getSkeletonWidth() {
    return this.width === undefined ? this.getRandomNumber() : this.width;
  }

  getRandomNumber() {
    const minimalColumnsWidth = this.getMinimalColumnsWidth();
    if (this.columnsHeader.length === 1) {
      return Math.floor(Math.random() * minimalColumnsWidth) + '%';
    } else {
      const maxValue = this.columnsHeader.length === 2 ? minimalColumnsWidth : minimalColumnsWidth + 35;
      const minValue = this.columnsHeader.length === 2 ? minimalColumnsWidth - 25 : minimalColumnsWidth;
      return Math.floor(Math.random() * maxValue + minValue) + '%';
    }
  }

  getColumnsHeader() {
    if (this.headers.length === 0) {
      this.getCustomHeaders();
    } else {
      this.columnsHeader = this.headers;
    }
  }

  getColumnsChangeHeader(changes: SimpleChanges) {
    if (changes.headers.currentValue.length === 0) {
      this.getCustomHeaders();
    } else {
      this.columnsHeader = changes.headers.currentValue;
    }
    this.getColumnsTableArray();
  }

  getCustomHeaders() {
    this.columnsHeader = [];
    let i = 0;
    while (i < this.columns) {
      this.columnsHeader = this.columnsHeader.concat('Ngx-SmartSkeleton ' + ++i);
      this.skeletonHeader = true;
    }
  }
}
